import { useCallback } from "react";
import { useShowProductPictures } from "stores/project";
import * as identify from "utils/treeUtils";
import type { RowHeightCalculatorParams } from "@hogartrabe/react-arborist-vrh/dist/module/types/tree-props";
import type { defaultOptions } from "variables/nodeDefaultOptions";
import type { Node } from "interfaces/schemas";

export const useCalculateRowHeight = (options: typeof defaultOptions) => {
  const showProductPictures = useShowProductPictures();

  const calculateRowHeight = useCallback(
    (node: RowHeightCalculatorParams<Node>) => {
      if (identify.isWizardCommissioningCost(node.data)) {
        return options.folderHeight;
      }
      if (identify.isAnyProduct(node.data) && showProductPictures) {
        return options.configurationHeight;
      }
      if (identify.isAnyProduct(node.data) && !showProductPictures) {
        return options.compactConfigurationHeight;
      }

      return options.folderHeight;
    },
    [options, showProductPictures],
  );

  return calculateRowHeight;
};
